import React, { type FC } from 'react';
import { defineMessages, useIntl } from 'react-intl-next';

import ChangesIcon from '@atlaskit/icon/core/changes';
import { IconButton } from '@atlaskit/button/new';
import Tooltip from '@atlaskit/tooltip';

const i18n = defineMessages({
	changeOwner: {
		id: 'content-ownership.content-owner-item.change-owner',
		defaultMessage: 'Change owner',
		description: 'An icon label within a button used to change the owner of a page',
	},
});

type ChangeContentOwnerButtonProps = {
	onClick: () => void;
	analyticsContext?: Record<string, any>;
};

export const ChangeContentOwnerButton: FC<ChangeContentOwnerButtonProps> = ({
	onClick,
	analyticsContext,
}) => {
	const { formatMessage } = useIntl();

	return (
		<Tooltip content={formatMessage(i18n.changeOwner)}>
			<IconButton
				appearance="subtle"
				icon={ChangesIcon}
				label={formatMessage(i18n.changeOwner)}
				onClick={onClick}
				analyticsContext={analyticsContext}
			/>
		</Tooltip>
	);
};
